var path = 'services/error-toast.tpl.html';
var html = " <md-toast class=tk-error-toast> <div class=md-toast-content> <div class=md-toast-text ng-bind-html=vm.message></div> <md-button ng-click=vm.closeToast()> {{ 'action.close' | translate }} </md-button> </div> </md-toast> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/services/error-toast.tpl.html
// module id = 1948
// module chunks = 1